import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Features {
  [key: string]: boolean;
}
export interface Languages {
  languageCode: string;
  languageLabel: string;
}

export interface StudyState {
  name: string;
  status: string;

  dataEditable: boolean;

  primaryColor: string;
  secondaryColor: string;
  textColor: string;
  secondaryTextColor: string;
  backgroundColor: string;
  features: Features;
  languages: Languages[];
  studyPermissions: any[];
  sitePermissions: { [key: string]: any };
  sitesList: any[];
  toggleLoader: boolean;
  subjectIdGeneration: string;
  displayLogic: string;
}

const initialState: StudyState = {
  name: "",
  status: "",
  primaryColor: "#327091",
  secondaryColor: "#E3F1F4",
  textColor: "#111928",
  secondaryTextColor: "#6B7280",
  backgroundColor: "#F4F5F7",
  features: {},
  languages: [],
  studyPermissions: [],
  sitesList: [],
  sitePermissions: {},
  toggleLoader: false,
  subjectIdGeneration: "incremental_per_site",
  dataEditable: false,
  displayLogic: "",
};

export const studySlice = createSlice({
  name: "study",
  initialState: initialState,
  reducers: {
    setStudyDetails: (
      state,
      action: PayloadAction<{
        status: string;
        primaryColor: string;
        secondaryColor: string;
        textColor: string;
        secondaryTextColor: string;
        backgroundColor: string;
        name: string;
        subjectIdGeneration: string;
        dataEditable: boolean;
        displayLogic: string;
      }>
    ) => {
      state.status = action.payload.status;
      state.primaryColor = action.payload.primaryColor;
      state.secondaryColor = action.payload.secondaryColor;
      state.textColor = action.payload.textColor;
      state.secondaryTextColor = action.payload.secondaryTextColor;
      state.backgroundColor = action.payload.backgroundColor;
      state.name = action.payload.name;
      state.subjectIdGeneration = action.payload.subjectIdGeneration;
      state.dataEditable = action.payload.dataEditable;
      state.displayLogic = action.payload.displayLogic;
    },
    setFeaturesList: (state, action: PayloadAction<Features>) => {
      state.features = action.payload;
    },
    setLanguagesList: (state, action: PayloadAction<Languages[]>) => {
      state.languages = action.payload;
    },
    setRbacState: (
      state,
      action: PayloadAction<{
        studyPermissions: string[];
        sitePermissions: { [key: string]: any };
        sitesList: any[];
      }>
    ) => {
      state.studyPermissions = action.payload.studyPermissions;
      state.sitePermissions = action.payload.sitePermissions;
      state.sitesList = action.payload.sitesList;
    },
    setStateToggle: (state) => {
      state.toggleLoader = !state.toggleLoader;
    },
    reset: () => initialState,
  },
});

export const {
  setStudyDetails,
  setFeaturesList,
  setLanguagesList,
  setRbacState,
  setStateToggle,
  reset,
} = studySlice.actions;

export default studySlice.reducer;
